import { Box } from "@mui/material";
import React from "react";

const YoutubeEmbed = ({ embedId }) => (
  <Box
    sx={{
      width: { xs: "95%", sm: "90%", md: "800px" },
      height: { xs: "310px", sm: "450px", md: "480px" },
    }}
  >
    <iframe
      width="100%" //853 480
      height="100%"
      src={`https://www.youtube.com/embed/${embedId}`}
      frameBorder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowFullScreen
      title="Embedded youtube"
    />
  </Box>
);

export default YoutubeEmbed;
